import React, { Component } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

class WebinarItem extends Component {

    render() {

        const { webinar, index } = this.props;

        // const hasAccess = webinar.series.filter( ( series ) => { return series.has_access === 1 } )[0];

        return (
            <div key={ index } className="col-xs-12 col-sm-6 col-lg-4 col-xl-3 text-center">
                <div className="webinar-item">
                    <div className="item-tile-header-background brand-background-color">
                    </div>
                    <div className="tile-info-box item-tile-background-image">
                        <div className="mask-grey padding-default">
                            <h5 className="h5 item-tile-title">{ webinar.name }</h5>
                            {/*todo: need var for date in the format dd/mm/yy*/}
                            <div className="pos-bottom">
                                <Link className="btn btn-primary" to={`/training/interactive-webinars/${ webinar.uid }`}>
                                    <span className="label">View webinar</span>
                                    <span className="icon"><i className="fa fa-angle-right animated-right"/></span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
}

WebinarItem.proptypes = {
    webinar: PropTypes.object.isRequired,
};

export default WebinarItem;



// WEBPACK FOOTER //
// src/client/components/site/features/training/webinars/pages/elements/WebinarItem.js